import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useFindPwRequestSms */
export type TypeFindPwRequestSmsParams = {
  /** 로그인 아이디 */
  username: string;
  /** 휴대전화 번호 */
  phoneNumber: string;
};

/** @category useFindPwRequestSms */
export type TypeFindPwRequestSmsResponse = {
  /** 응답 메시지 */
  message: string;
};

/**
 * @description 비밀번호 초기화 > 인증번호 요청 api 요청에 사용되는 커스텀 훅
 */
export const useFindPwRequestSms = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeFindPwRequestSmsParams) => {
      const endpoint = '/labor-accounts/phone-verification/for-modify-password';
      return axiosInstance.post(endpoint, params, { headers: { withoutToken: true } });
    },
  });

  const requestFindPwRequestSms = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeFindPwRequestSmsParams;
    onSuccess?: (res: TypeFindPwRequestSmsResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestFindPwRequestSms;
};
